<script>
import UserMenu from '@phoenix/mixins/components/myAccount/nav/UserMenu';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [UserMenu],

  data: () => ({
    linkClass: 'menu-list__link menu-list__link--title menu-list__link--primary',
  }),
};
</script>

<template>
  <ul class="menu">
    <li v-for="page in links" :key="page.title" class="menu__item">
      <button v-if="page.isLogout" class="menu__entry menu__link menu__toggle" :data-cy="page.dataCy" @click="logout">
        <span class="menu__label menu__label--inset">
          {{ page.title }}
        </span>
      </button>
      <a v-else :href="page.link" class="menu__entry menu__link menu__toggle">
        <span class="menu__label">
          <phx-icon :icon="page.icon" class="icon-- me-sm"></phx-icon>
          {{ page.title }}
        </span>
        <phx-icon icon="chevron-16" class="icon--" bidirectional></phx-icon>
      </a>
    </li>
  </ul>
</template>
